module.exports = __webpack_public_path__ + "static/img/12.ffe9ec2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/4/zh/12.png
// module id = kfHK
// module chunks = 0